import { WeaTools } from 'ecCom';
export const url = '/api/cube/graph'
export const initMind = (params) => {
    return WeaTools.callApi(`${url}/getMindData`, "get", params);
}
export const mindSubData = (params) => {
    return WeaTools.callApi(`${url}/getMindSub`, "get", params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/apis/mind.ts